import clsx from 'clsx'
import { connect } from 'react-redux'
import './LayoutLoading.scss'

interface ILoading {
    isLoading?: boolean
    className?: string
}

function LayoutLoading({ isLoading, className }: ILoading) {
    return (
        <>
            {isLoading && (
                <div className={clsx(className, 'spinner')}>
                    <div className="rect1 mr-1 main-bg" />
                    <div className="rect2 mr-1 bg-dark-shade-blue" />
                    <div className="rect3 mr-1 main-bg" />
                    <div className="rect4 mr-1 bg-dark-shade-blue" />
                    <div className="rect5 mr-1 main-bg" />
                </div>
            )}
        </>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { isLoading } = state?.auth
    return {
        isLoading,
    }
}

export default connect(mapStateToProps, null)(LayoutLoading)
